// tslint:disable-next-line:typedef
export const RouteNames = {
    ROOT: "/",
    TRAVEL: "/travel",
    PUBLICATIONS: "/publications",
    SOFTWARE: "/software",
    CONTACT: "/contact",
    INVIS_DEMO: "/invis-demo",
    CV: "/files/CV_Florian_Chen.pdf",
};
